<template>
	<div class="line">
		<div ref="linechart" class="linechart" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false">
		</div>
	</div>
</template>

<script>
import * as methods from './method.js'
export default {
	name: 'template.scope51',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => { }
		}
	},
	data() {
		return {
			title: '基本面积图-scope51',
			timer: null,
			defaultdata: [
				{ value1: '1月', value2: '80', value3: '系列一', value4: '元' },
				{ value1: '2月', value2: '40' },
				{ value1: '3月', value2: '62' },
				{ value1: '4月', value2: '90' },
				{ value1: '5月', value2: '62' },
				{ value1: '6月', value2: '60' },
				{ value1: '7月', value2: '40' },
			],
			valueMap: [
				{ name: '名称', key: "value1" },
				{ name: '数值', key: "value2" },
				{ name: '图例', key: 'value3' },
				{ name: '单位', key: 'value4' },
			],
			exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
			config: {
			},
			autoTimePaused: false,
		}
	},
	watch: {
		vdata(n) {
			if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
		defaultdata(n) {
			this.DrawEcharts()
		}
	},
	beforeDestroy() {
		clearInterval(this.timer);
		this.timer = null
	},
	methods: {
		...methods,
		DrawEcharts() {
			clearInterval(this.timer);
			this.timer = null;
			var echarts = require("echarts");
			var TmyChart = echarts.init(this.$refs.linechart);
      		let unit = this.defaultdata[0].value4 || ''
			let mydata = this.defaultdata.map((item) => {
				return {
					name: item.value1,
					value: item.value2,
				};
			});

			const xAxis = this.defaultdata.map((item) => item.value1);
			const percent = (9 / xAxis.length) * 100;
			let zoom = [
				{
					id: "scope51", // 唯一的id
					filterMode: "empty",
					xAxisIndex: 0, //滑动条为竖
					mayValueSpan: 9, // 显示数据的条数(默认显示10个)
					type: "slider",
					showDetail: false, //关闭：拖拽时候显示详细数值信息。
					dataBackground: {
						show: false,
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					selectedDataBackground: {
						lineStyle: {
							opacity: 0,
						},
						areaStyle: {
							opacity: 0,
						},
					},
					backgroundColor: "transparent",
					fillerColor: "transparent",
					borderColor: "transparent",
					start: 0,
					end: percent,
					top: "80%",
					height: "5%",
					z: 2,
					zlevel: 3, //重点，层级必须设置大于柱状图
				},
			];
			var Toption = {
				title: [
					{
						text: unit,
						top: "0",
						left: "0",
						textStyle: {
							color: "#979AA0",
							fontSize: 12,
						},
					},
				],
				tooltip: {
					trigger: "axis",
				},
				grid: {
					left: "5px",
					right: "10px",
					bottom: "0px",
					top: "40px",
					containLabel: true,
				},
				legend: [
					{
						top: "0%",
						right: 50,
						itemHeight: 6, //图例的高度  文字左边那个
						itemWidth: 12,
						icon: "rect",
						textStyle: { color: "#bdc2cb", width: 80, overflow: 'truncate' },
						data: [this.defaultdata[0].value3 || ""],
					},
				],
				xAxis: {
					type: "category",
					boundaryGap: false,
					axisTick: {
						show: false,
					},

					axisPointer: {
						type: "shadow",
					},
					axisLabel: {
						interval: xAxis.length > 12 ? 0 : 0 || xAxis.length > 9 ? 1 : 0,
						width: 50,
						overflow: 'truncate', //文字超出宽度截断，默认为...
						
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
							fontSize: "14",
							lineHeight: 16,
						},
						formatter: function (value) {
							return value
						},
					},
					axisLine: {
						lineStyle: {
							// X 轴颜色配置
							color: "#4792e9",
						},
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
					data: mydata.map((item) => item.name),
				},

				yAxis: {
					type: "value",
					splitNumber: 2,
					axisLabel: {
						textStyle: {
							color: "#bdc2cb", // 这里将 x 轴文本颜色设为灰白色
						},
						fontSize: 14,
					},
					axisLine: {
						show: false,
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: "dashed",
							color: "rgba(231,241,251,.2)",
						},
					},
				},
				series: [
					{
						name: this.defaultdata[0].value3 || "",
						showSymbol: false,
						smooth: true,
						data: mydata,
						type: "line",
						areaStyle: {},
						symbol: "none",
						lineStyle: {
							color: "#0182fc",
							width: 2,
						},
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[
										{
											offset: 0,
											color: "#007EFF", // 0% 处的颜色
										},
										{
											offset: 0.8,
											color: "rgba(35,216,234,0.00)",
										},
									],
									false
								),
							},
						},
					},
				],
				dataZoom: xAxis.length > 9 ? zoom : [],
			};
			Toption && TmyChart.setOption(Toption);
			this.timer = setInterval(() => {
				if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000);
		},
	},
	created() {

	},
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
		this.setData()
		this.DrawEcharts(); //需要刷新的数据
	},
}
</script>

<style scoped>
.line {
	width: 435px;
	height: 240px;
	display: flex;
	position: relative;
	overflow: hidden;
	padding: 10px 0;
}

.linechart {
	width: 100%;
	height: 100%;
}
</style>